<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import Slider from '../components/Slider.svelte'

  let slideData = [
    {
      caption: '<strong class="accent">Identity at the core:</strong> Leverage our identity graph to target precise audiences in CTV and also leverage our proprietary CTV measurement solutions all as Value Add.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1616188608/VerizonMediaATV/digital-lockscroll-img1-mobile_iojjjj.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1616188608/VerizonMediaATV/digital-lockscroll-img1-desktop_ujwwex.jpg',
      altText: 'Woman on floor pointing remote control at TV'
    },
    {
      caption: '<strong class="accent">Trusted supply:</strong> Access premium and trusted supply in CTV/OTT and Addressable linear, and use Omniscope to help you navigate the CTV supply landscape.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1616188608/VerizonMediaATV/digital-lockscroll-img2-mobile_fao7ct.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1616188608/VerizonMediaATV/digital-lockscroll-img2-desktop_psweai.jpg',
      altText: 'Woman with glasses using TV remote control'
    },
    {
      caption: '<strong class="accent">Connecting the dots:</strong> You can bridge the gap between linear and digital with our Cross-Screen Planner and our comprehensive measurement partnerships.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/digital-lockscroll-img3-mobile_pezzon.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/digital-lockscroll-img3-desktop_qxjcqg.jpg',
      altText: 'Father and daughter watching TV'
    },
  ]
</script>
<section class="part8 no-max-width">
  <div class="content">
    <div class="rgrid-md-1-2">
      <div class="col">
        <AnimatedLine size={5} color="white" />
        <AnimatedTitle class="large">Why Verizon Media DSP for Advanced TV?</AnimatedTitle>
      </div>
    </div>
  </div>
  <div class="slider-wrap">
    <Slider slides={slideData} useFullWidth={true} />
  </div>
</section>

<style>
  .slider-wrap {
    margin-top: 3rem;
  }
  section :global(.hline) {
    margin-bottom: 0.625rem;
  }
</style>
